import { CIcon } from '~/icons/types'

export const ciSale: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.543 0H2.4a.5.5 0 1 0 0 1h2.43v2.826H2.457A1.458 1.458 0 0 0 1 5.283v10.522a1.458 1.458 0 0 0 1.457 1.456h17.217a1.458 1.458 0 0 0 1.456-1.456V5.283a1.458 1.458 0 0 0-1.456-1.457h-3.326V1h6.2a.458.458 0 0 1 .452.457V22.5a.5.5 0 0 0 1 0V1.457A1.459 1.459 0 0 0 22.543 0ZM20.13 5.283v10.522a.456.456 0 0 1-.456.456H2.457A.457.457 0 0 1 2 15.805V5.283a.458.458 0 0 1 .457-.457h17.217a.457.457 0 0 1 .456.457Zm-4.782-1.457H5.826V1h9.522v2.826Z'
    },
    {
      d:
        'M13.935 12.435h-.956a.458.458 0 0 1-.458-.457V8.152a.5.5 0 0 0-1 0v3.826a1.459 1.459 0 0 0 1.458 1.457h.956a.5.5 0 1 0 0-1ZM5.326 8.652h.957a.5.5 0 1 0 0-1h-.957A1.458 1.458 0 0 0 3.87 9.11a2.233 2.233 0 0 0 1.156 1.834c.484.363.757.59.757 1.035a.458.458 0 0 1-.457.457H4.37a.5.5 0 0 0 0 1h.956a1.459 1.459 0 0 0 1.457-1.457 2.231 2.231 0 0 0-1.156-1.834c-.483-.363-.757-.589-.757-1.035a.457.457 0 0 1 .456-.457Zm3.826-1A1.459 1.459 0 0 0 7.7 9.11v3.826a.5.5 0 1 0 1 0v-1.413h.913v1.413a.5.5 0 1 0 1 0V9.11a1.46 1.46 0 0 0-1.461-1.457Zm-.452 2.87V9.11a.457.457 0 1 1 .913 0v1.413H8.7Zm6.648-1.412v2.868a1.459 1.459 0 0 0 1.457 1.457h.956a.5.5 0 1 0 0-1h-.956a.458.458 0 0 1-.457-.457v-.456h1.413a.5.5 0 1 0 0-1h-1.413V9.11a.458.458 0 0 1 .457-.457h.956a.5.5 0 0 0 0-1h-.956a1.459 1.459 0 0 0-1.457 1.457Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'sale',
  type: 'thin'
}
